import React from "react";
import { Form, Input, Card, Select, Switch, Radio, } from 'antd';
import { Info, } from "@phosphor-icons/react";
import { FormattedMessage, useIntl, } from "react-intl";
import { Controller, } from "react-hook-form";
import { COUNTRIES, } from '../../../../constants/countries';  // default for Netherlands = nl
import { CheckUserExists, } from '../../../../services/users';
import CustomerUserGroupsFormView from './customer.user.groups.form.view';

const CustomerFormView = ({
    modalIsOpen,
    modalIsOpenHandler,
    refreshData,
    history,
    control,
    watch,
    editMode,
    hideProfileFields,
    userGroups,
    ...props
}) => {

    const intl = useIntl();
    const customerType = watch("customer_type");
    const customer_billing_enable = watch("customer_billing_enable");
    // const { permissionTemplate: { system_user_permissions } } = props;

    // Get current user details
    const localdata = sessionStorage.getItem('authentication');
    const { permission } = JSON.parse(localdata);

    const options = [
        {
            label: "Consument",
            value: "CONSUMER"
        },
        {
            label: "Bedrijf",
            value: "COMPANY"
        },
    ];

    customerType === 'DEALER' && options.push({ label: "Dealer", value: "DEALER" });

    const filterOption = (input, option) => {
        return option.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    return (

        <React.Fragment>

            {/* customer basic card */}
            <Card title={<h4><FormattedMessage id="customer-details-basic" /></h4>}>
                <Form
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}>

                    {/* Choose company, Customer or Dealer */}
                    <FormattedMessage id="customer-company">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue={false}
                                name="customer_type"
                                rules={{}}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        label={<strong>{NameField}</strong>}>
                                        <Radio.Group
                                            disabled={editMode === "edit" && customerType === "DEALER"}
                                            options={options}
                                            onChange={onChange}
                                            value={value}
                                            optionType="button"
                                        />
                                    </Form.Item>
                                )}
                            />}
                    </FormattedMessage>

                    <Form.Item
                        label={<strong><FormattedMessage id={(customerType === "COMPANY" || customerType === "DEALER") ? ("contact-person") : ("customer-name")} /></strong>}
                        required
                        style={{ marginBottom: 0 }}>
                        <FormattedMessage id="first-name">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="customer_firstname"
                                    rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                        // label={<FormattedMessage id="firstname-and-lastname" />}
                                        >
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />}
                        </FormattedMessage>

                        <FormattedMessage id="last-name">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="customer_lastname"
                                    rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}>
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />}
                        </FormattedMessage>
                    </Form.Item>

                    {/* Customer fields if company */}
                    {(customerType === "COMPANY" || customerType === "DEALER") && (
                        <React.Fragment>

                            <FormattedMessage id="company-name">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="customer_name"
                                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                required
                                                label={<strong>{NameField}</strong>}>
                                                <Input
                                                    onChange={onChange}
                                                    value={value}
                                                    placeholder={NameField}

                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* company registration number */}
                            <FormattedMessage id="company-registration-number">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="customer_registration_number"
                                        // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                label={<strong>{NameField}</strong>}>
                                                <Input type="number" onChange={onChange}
                                                    value={value}
                                                    placeholder={NameField}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* Company VAT number */}
                            <FormattedMessage id="company-vat-number">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="customer_vat_number"
                                        // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                label={<strong>{NameField}</strong>}>
                                                <Input
                                                    onChange={onChange}
                                                    value={value}
                                                    placeholder={NameField}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* Shift vat */}
                            <FormattedMessage id="company-vat-shifted">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue={false}
                                        name="customer_vat_shifted"
                                        rules={{}}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                className="mt-4"
                                                labelCol={{ span: 10 }}
                                                wrapperCol={{ span: 14 }}
                                                // help={error && intl.formatMessage({ id: error?.message })}
                                                // hasFeedback
                                                // validateStatus={error?.message && "error"}
                                                label={<strong>{NameField}</strong>}>
                                                <Switch
                                                    onChange={onChange}
                                                    checked={value}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                        </React.Fragment>
                    )}


                    <FormattedMessage id="customer-po">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue=""
                                name="customer_po_number"
                                // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        // help={error && intl.formatMessage({ id: error?.message })}
                                        // hasFeedback
                                        // validateStatus={error?.message && "error"}
                                        // required
                                        label={<strong>{NameField}</strong>}>
                                        <Input onChange={onChange}
                                            value={value}
                                            placeholder={NameField}
                                        />
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>
                </Form>
            </Card>

            {/* Customer address card */}
            <Card className="mt-4" title={<h4><FormattedMessage id="customer-details-address" /></h4>}>
                <Form
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}>

                    {/* Street number */}
                    <FormattedMessage id="customer-street-number">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue=""
                                name="street_number"
                                rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        help={error && intl.formatMessage({ id: error?.message })}
                                        hasFeedback
                                        validateStatus={error?.message && "error"}
                                        required
                                        label={<strong>{NameField}</strong>}>
                                        <Input
                                            placeholder={NameField}
                                            onChange={onChange}
                                            value={value}
                                        />
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>

                    {/* zipcode and city form */}
                    <Form.Item
                        label={<strong><FormattedMessage id="customer-zip-city" /></strong>}
                        required
                        style={{ marginBottom: 0 }}>
                        {/* zipcode form */}
                        <FormattedMessage id="zip-code">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="zip_code"
                                    rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                        // label={<FormattedMessage id="firstname-and-lastname" />}
                                        >
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />
                            }
                        </FormattedMessage>

                        {/* city form */}
                        <FormattedMessage id="city">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="city"
                                    rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}>
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />
                            }
                        </FormattedMessage>
                    </Form.Item>

                    {/* Country */}
                    <FormattedMessage id="country">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue={'nl'}
                                name="country"
                                rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        help={error && intl.formatMessage({ id: error?.message })}
                                        hasFeedback
                                        validateStatus={error?.message && "error"}
                                        label={<strong>{NameField}</strong>}
                                        required>
                                        <Select
                                            showSearch
                                            filterOption={filterOption}
                                            value={value}
                                            onChange={onChange}
                                            placeholder={intl.formatMessage({ id: 'make-choice' })}
                                            options={COUNTRIES.map(title => ({ id: title.code, value: title.code, label: title.name }))}
                                        />
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>
                </Form>
            </Card>


            {/* contact card */}
            <Card className="mt-4" title={<h4><FormattedMessage id="customer-details-contact" /></h4>}>
                <Form
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}>

                    {/* email address */}
                    {editMode === "edit" ? (
                        <FormattedMessage id="emailaddress">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="customer_email"
                                    rules={{
                                        required: { value: true, message: "inputfield-FieldIsRequired" },
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i,
                                            message: "EmailAddressNotValid",
                                        },
                                        // validate: {
                                        //     checkemail: async (value) => {
                                        //         if (!value) { return true };
                                        //         return CheckUserExists({ user_email: value }, history).then(response => {
                                        //             if (response.data.email_exists) { return 'EmailAddressAlreadyExist' }
                                        //         });
                                        //     }
                                        // }
                                    }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            label={<strong>{NameField}</strong>}>
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />}
                        </FormattedMessage>
                    ) : (
                        <FormattedMessage id="emailaddress">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="customer_email"
                                    rules={{
                                        required: { value: true, message: "inputfield-FieldIsRequired" },
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i,
                                            message: "EmailAddressNotValid",
                                        },
                                        validate: {
                                            checkemail: async (value) => {
                                                if (!value) { return true };
                                                return CheckUserExists({ user_email: value }, history)
                                                    .then(response => {
                                                        if (response.data.email_exists) { return 'EmailAddressAlreadyExist' }
                                                    })
                                                    .catch(error => { });
                                            }
                                        }
                                    }}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            help={error && intl.formatMessage({ id: error?.message })}
                                            hasFeedback
                                            validateStatus={error?.message && "error"}
                                            required
                                            label={<strong>{NameField}</strong>}>
                                            <Input
                                                placeholder={NameField}
                                                onChange={onChange}
                                                value={value}
                                            />
                                        </Form.Item>
                                    )}
                                />}
                        </FormattedMessage>
                    )}

                    {/* send welcome mail */}
                    {editMode === "add" && (
                        <FormattedMessage id="send-welcome-mail">
                            {NameField =>
                                <Controller
                                    control={control}
                                    defaultValue={false}
                                    name="send_welcome_mail"
                                    rules={{}}
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { error },
                                    }) => (
                                        <Form.Item
                                            label={<strong>{NameField}</strong>}>
                                            <Switch
                                                placeholder={NameField}
                                                onChange={onChange}
                                                checked={value}
                                            />
                                            <small className="form-text text-muted">
                                                <Info size={16} weight="light" className="mx-1" /> <FormattedMessage id="send-welcome-mail-tt" /></small>
                                        </Form.Item>
                                    )}
                                />}
                        </FormattedMessage>
                    )}

                    {/* phone number */}
                    <FormattedMessage id="phonenumber">
                        {NameField =>
                            <Controller
                                control={control}
                                // defaultValue=""
                                name="customer_phone_number"
                                rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        help={error && intl.formatMessage({ id: error?.message })}
                                        hasFeedback
                                        validateStatus={error?.message && "error"}
                                        required
                                        label={<strong>{NameField}</strong>}>
                                        <Input
                                            placeholder={NameField}
                                            onChange={onChange}
                                            value={value}
                                        />
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>

                    {/* customer_preference_language */}
                    <FormattedMessage id="preference-language">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue=""
                                name="customer_preference_language"
                                rules={{
                                    required: { value: true, message: "inputfield-FieldIsRequired" },
                                }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        help={error && intl.formatMessage({ id: error?.message })}
                                        hasFeedback
                                        validateStatus={error?.message && "error"}
                                        label={<strong>{NameField}</strong>}
                                        required>
                                        <Select
                                            placeholder={NameField}
                                            onChange={onChange}
                                            value={value}>
                                            <Select.Option key="" value=""><FormattedMessage id="make-choice" /></Select.Option>
                                            <Select.Option key="nl" value="nl"><FormattedMessage id="dutch" /></Select.Option>
                                            <Select.Option key="en" value="en"><FormattedMessage id="english" /></Select.Option>
                                            <Select.Option key="de" value="de"><FormattedMessage id="german" /></Select.Option>
                                        </Select>
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>


                    {/* Billing address enabled */}
                    <FormattedMessage id="use-billing-address">
                        {NameField =>
                            <Controller
                                control={control}
                                defaultValue={false}
                                name="customer_billing_enable"
                                // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                render={({
                                    field: { onChange, onBlur, value, name, ref },
                                    fieldState: { error },
                                }) => (
                                    <Form.Item
                                        label={<strong>{NameField}</strong>}>
                                        <Switch
                                            placeholder={NameField}
                                            onChange={onChange}
                                            value={value}
                                        />
                                        <small className="form-text text-muted">
                                            <Info size={16} weight="light" className="mx-1" /> <FormattedMessage id="use-billing-address-tt" /></small>
                                    </Form.Item>
                                )}
                            />
                        }
                    </FormattedMessage>

                    {customer_billing_enable && (
                        <React.Fragment>

                            {/* billing name  */}
                            <FormattedMessage id="billing-name">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        // defaultValue=""
                                        name="customer_billing_name"
                                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                required
                                                label={<strong>{NameField}</strong>}>
                                                <Input
                                                    placeholder={NameField}
                                                    onChange={onChange}
                                                    value={value}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* Street number */}
                            <FormattedMessage id="customer-street-number">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="billing_street_number"
                                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                required
                                                label={<strong>{NameField}</strong>}>
                                                <Input
                                                    placeholder={NameField}
                                                    onChange={onChange}
                                                    value={value}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* zipcode and city form */}
                            <Form.Item
                                label={<strong><FormattedMessage id="customer-zip-city" /></strong>}
                                required
                                style={{ marginBottom: 0 }}>
                                {/* zipcode form */}
                                <FormattedMessage id="zip-code">
                                    {NameField =>
                                        <Controller
                                            control={control}
                                            defaultValue=""
                                            name="billing_zip_code"
                                            rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { error },
                                            }) => (
                                                <Form.Item
                                                    help={error && intl.formatMessage({ id: error?.message })}
                                                    hasFeedback
                                                    validateStatus={error?.message && "error"}
                                                    required
                                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                                // label={<FormattedMessage id="firstname-and-lastname" />}
                                                >
                                                    <Input
                                                        placeholder={NameField}
                                                        onChange={onChange}
                                                        value={value}
                                                    />
                                                </Form.Item>
                                            )}
                                        />
                                    }
                                </FormattedMessage>

                                {/* city form */}
                                <FormattedMessage id="city">
                                    {NameField =>
                                        <Controller
                                            control={control}
                                            defaultValue=""
                                            name="billing_city"
                                            rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                            render={({
                                                field: { onChange, onBlur, value, name, ref },
                                                fieldState: { error },
                                            }) => (
                                                <Form.Item
                                                    help={error && intl.formatMessage({ id: error?.message })}
                                                    hasFeedback
                                                    validateStatus={error?.message && "error"}
                                                    required
                                                    style={{ display: 'inline-block', width: 'calc(50% - 8px)', margin: '0 8px' }}>
                                                    <Input
                                                        placeholder={NameField}
                                                        onChange={onChange}
                                                        value={value}
                                                    />
                                                </Form.Item>
                                            )}
                                        />
                                    }
                                </FormattedMessage>
                            </Form.Item>

                            {/* Country */}
                            <FormattedMessage id="country">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue={'nl'}
                                        name="billing_country"
                                        rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                label={<strong>{NameField}</strong>}
                                                required>
                                                <Select
                                                    showSearch
                                                    filterOption={filterOption}
                                                    value={value}
                                                    onChange={(e) => { onChange(e) }}>
                                                    <Select.Option value="">{intl.formatMessage({ id: 'make-choice' })}</Select.Option>
                                                    {COUNTRIES.map(title => (
                                                        <Select.Option key={title.code} value={title.code}>
                                                            {title.name}
                                                        </Select.Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>

                            {/* Billing mail address */}
                            <FormattedMessage id="emailaddress">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="customer_billing_email"
                                        rules={{
                                            required: { value: true, message: "inputfield-FieldIsRequired" },
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i,
                                                message: "EmailAddressNotValid",
                                            }
                                        }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                required
                                                label={<strong>{NameField}</strong>}>
                                                <Input
                                                    placeholder={NameField}
                                                    onChange={onChange}
                                                    value={value}
                                                />
                                            </Form.Item>
                                        )}
                                    />}
                            </FormattedMessage>

                        </React.Fragment>
                    )}
                </Form>
            </Card>

            {/* User groups for customer  access */}
            {permission !== "users" && (
                <Card
                    className="my-4"
                    title={<h4><FormattedMessage id="customer-user-groups" /></h4>}>
                    <CustomerUserGroupsFormView
                        userGroups={userGroups}
                        history={history}
                        control={control}
                        {...props}
                    />
                </Card>
            )}

            {/* customer additional card */}
            {permission !== "users" && (
                <Card className="mt-4" title={<FormattedMessage id="customer-details-additional" />}>
                    <Form
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}>

                        {/* customer note card */}
                        {hideProfileFields ? (null) : (
                            <FormattedMessage id="notes">
                                {NameField =>
                                    <Controller
                                        control={control}
                                        defaultValue=""
                                        name="customer_note"
                                        // rules={{ required: { value: true, message: "inputfield-FieldIsRequired" } }}
                                        render={({
                                            field: { onChange, onBlur, value, name, ref },
                                            fieldState: { error },
                                        }) => (
                                            <Form.Item
                                                help={error && intl.formatMessage({ id: error?.message })}
                                                hasFeedback
                                                validateStatus={error?.message && "error"}
                                                // required
                                                label={<strong>{NameField}</strong>}>

                                                <Input.TextArea
                                                    placeholder={NameField}
                                                    onChange={onChange}
                                                    value={value}
                                                />
                                            </Form.Item>
                                        )}
                                    />
                                }
                            </FormattedMessage>
                        )}
                    </Form>
                </Card>
            )}

        </React.Fragment>
    );
};

export default CustomerFormView;